import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import styles from "./TextInput.module.css";

const TextInput = ({
	label,
	type = "text",
	placeholder,
	value,
	onChange,
	error,
	disabled = false,
	icon,
	required = false,
}) => {
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword((prevState) => !prevState);
	};

	return (
		<div className={styles.inputContainer}>
			{label && (
				<label className={styles.label}>
					{label}
					{required && <span className={styles.required}>*</span>}
				</label>
			)}

			<div className={styles.inputWrapper}>
				{icon && (
					<span className={styles.iconWrapper}>
						<FontAwesomeIcon icon={icon} className={styles.icon} />
					</span>
				)}

				<input
					type={type === "password" && showPassword ? "text" : type}
					className={`${styles.input} ${error ? styles.inputError : ""} ${
						icon ? styles.hasIcon : ""
					}`}
					placeholder={placeholder}
					value={value}
					onChange={onChange}
					disabled={disabled}
					required={required}
				/>

				{type === "password" && (
					<button
						type="button"
						className={styles.passwordToggle}
						onClick={togglePasswordVisibility}
					>
						<FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
					</button>
				)}
			</div>

			{error && <div className={styles.errorText}>{error}</div>}
		</div>
	);
};

export default TextInput;
